import type { UpgradePreview } from "@/react/types/Paywalls/Checkout/UpgradePreview";

type PriceOption = UpgradePreview["price_options"][number];

export interface UpgradePriceComparison {
  /** The displayed amount for the current previewed term. */
  amount: string;
  /** The list or authored before-price. */
  beforeAmount?: string;
}

/** Coupon terms come only from a Stripe preview for this price. */
export const upgradePriceComparison = (
  priceOption: PriceOption,
): UpgradePriceComparison => ({
  amount:
    priceOption.coupon_term_amount?.formatted ??
    priceOption.list_amount.formatted,
  beforeAmount: priceOption.coupon_term_amount?.formatted
    ? priceOption.list_amount.formatted
    : priceOption.reduced_list_amount?.formatted,
});

export const upgradeSourceCycleAmount = (
  priceOption: PriceOption,
  sourceIntervalType: PriceOption["interval_type"],
): string | undefined => {
  if (!priceOption.source_cycle_amount) return;

  return priceOption.interval_type === sourceIntervalType
    ? upgradePriceComparison(priceOption).amount
    : (priceOption.coupon_source_cycle_amount?.formatted ??
        priceOption.source_cycle_amount.formatted);
};
